"use strict";

var _dataFixerMandatoryNo;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var IS_HTTPS = 'isHttps';
var IS_URL_MIGRATED = 'isUrlMigrated';
var METASITE_ID = 'metaSiteId';
var QAME = 'quickActionsMenuEnabled';
var SITE_ID = 'siteId';
var PAGE_ID = 'pageId';
var PAGE_COMP_ID = 'pageCompId';
var DF_VERSION = 'dfVersion';
var MODULE = 'module';
var MODULE_VERSION = 'moduleVersion';
var FILE_ID = 'fileId';
var CK = 'ck';
var DF_CK = 'dfCk';
var MODULE_CK = 'mCk';
var EXPERIMENTS = 'experiments';
var SHARED_CACHE_POC = 'sharedCachePoc';
var SITE_REVISION = 'siteRevision';
var VERSION = 'version';
var SHOULD_DISABLE_ONE_DOC = 'shouldDisableOneDoc';
var dataFixerParamNames = [CK, DF_CK, DF_VERSION, EXPERIMENTS, IS_HTTPS, IS_URL_MIGRATED, METASITE_ID, MODULE_CK, PAGE_ID, PAGE_COMP_ID, QAME, SHARED_CACHE_POC, SITE_ID, SITE_REVISION, VERSION, SHOULD_DISABLE_ONE_DOC];
var dataFixerMandatoryNonEmptyParams = (_dataFixerMandatoryNo = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_dataFixerMandatoryNo, CK, CK), DF_CK, DF_CK), DF_VERSION, DF_VERSION), IS_HTTPS, IS_HTTPS), IS_URL_MIGRATED, IS_URL_MIGRATED), METASITE_ID, METASITE_ID), PAGE_ID, [PAGE_ID, PAGE_COMP_ID]), PAGE_COMP_ID, [PAGE_ID, PAGE_COMP_ID]), QAME, QAME), SITE_ID, SITE_ID), _defineProperty(_defineProperty(_dataFixerMandatoryNo, MODULE_VERSION, [MODULE_VERSION, FILE_ID]), FILE_ID, [MODULE_VERSION, FILE_ID]));
var reservedParamNames = [].concat(dataFixerParamNames, [MODULE, MODULE_VERSION]);
var either = function either(a, b) {
  return function (p) {
    return p === a || p === b;
  };
};
var mandatoryPageModuleRequestParams = [IS_HTTPS, IS_URL_MIGRATED, METASITE_ID, QAME, SITE_ID, either(PAGE_ID, PAGE_COMP_ID), MODULE, either(MODULE_VERSION, FILE_ID), DF_VERSION];
var mandatorySiteModuleRequestParams = [IS_HTTPS, IS_URL_MIGRATED, METASITE_ID, QAME, SITE_ID, MODULE, either(MODULE_VERSION, FILE_ID), DF_VERSION];
module.exports = {
  dataFixerParamNames: dataFixerParamNames,
  reservedParamNames: reservedParamNames,
  dataFixerMandatoryNonEmptyParams: dataFixerMandatoryNonEmptyParams,
  mandatoryPageModuleRequestParams: mandatoryPageModuleRequestParams,
  mandatorySiteModuleRequestParams: mandatorySiteModuleRequestParams
};
//# sourceMappingURL=consts.js.map